<app-please-wait [hidden]="!loading"></app-please-wait>
<form [formGroup]="form" (ngSubmit)="onSubmit()" class="tabbed-dialog-layout" pFocusTrap>
  <div class="tabbed-dialog-body">
    <p class="w-full">Ange startdatum, dvs. från vilken period tjänsten ska utföras</p>
    <div class="mb-5 flex justify-between">
      <div class="flex items-end">
        <div>
          <!-- <p>Föreslaget startdatum</p> -->
          <app-calendar
            appendTo="body"
            formControlName="startDate"
            [style]="{ 'max-width': '160px' }"
            [invalid]="form.controls.startDate.invalid"
            label="Startdatum"
            class="flex flex-col"
            [title]="
              form.controls.startDate.errors?.startDate?.message ||
              'ex. Om tjänsten ska utföras från oktober månad ange 2021-10-01'
            ">
          </app-calendar>
        </div>
        <div class="flex items-end" [ngClass]="{ 'ml-2': !lastTaskGroupId }">
          <app-task-groups-selector
            appendTo="body"
            (onTaskGroupChanged)="onTaskGroupChanged($event)"
            [disabled]="loading">
          </app-task-groups-selector>
        </div>
      </div>
      <div class="flex">
        <div *ngIf="!lastTaskGroupId" class="flex items-end">
          <bl-frontend-button
            text="Importera från Uppdragsmallar"
            (onclick)="loadProposals()"
            title="Hämta förslag från uppdragsmallarna"
            class="ml-4"></bl-frontend-button>
        </div>
      </div>
    </div>
    <p-table
      [columns]="columns"
      [value]="taskTemplates$ | async"
      [selection]="selectedTaskTemplates"
      (selectionChange)="onTaskTemplatesSelected($event)"
      scrollHeight="310px"
      dataKey="id"
      sortField="assignmentName"
      #table>
      <ng-template pTemplate="caption">
        <div class="flex">
          <span class="p-input-icon-left">
            <bl-frontend-text-input
              [leftIcon]="{ name: 'search' }"
              (valueChange)="table.filterGlobal($event, 'contains')"
              placeholder="Sök">
            </bl-frontend-text-input>
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 1">
            <div class="my-3">{{ tableMessage }}</div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 3.4em">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th class="font-normal truncate" *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon
              [field]="col.field"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-task>
        <tr>
          <ng-container *ngIf="isExistingTemplate(task)">
            <td>
              <p-checkbox formControlName="selected" [binary]="true"></p-checkbox>
            </td>
            <td class="truncate text-bl-grey-300">
              {{ task.assignmentName }}
            </td>
            <td class="truncate text-bl-grey-300">
              {{ task.type }}
            </td>
            <td class="truncate text-bl-grey-300">
              {{ task.usersAsString }}
            </td>
          </ng-container>
          <ng-container *ngIf="!isExistingTemplate(task)">
            <td>
              <p-tableCheckbox [value]="task"></p-tableCheckbox>
            </td>
            <td class="truncate">
              {{ task.assignmentName }}
            </td>
            <td class="truncate">
              {{ task.type }}
            </td>
            <td class="truncate">
              {{ task.usersAsString }}
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="relative">Antal valda tjänster att lägga till: {{ form.value.taskTemplates?.length }}</div>
      </ng-template>
    </p-table>
  </div>
  <div class="tabbed-dialog-actions flex justify-end items-end p-4 bg-bl-grey-100">
    <bl-frontend-button variant="secondary" text="Stäng" (onclick)="close({ taskTemplates: null })">
    </bl-frontend-button>
    <bl-frontend-button [disabled]="form.invalid || form.pristine" text="Spara" type="submit"> </bl-frontend-button>
  </div>
</form>
